export default "__VITE_ASSET__6e79cd05__"